import { Box, Typography } from '@mui/material';
import { colors } from '@/@mui/tokens/colors';

const styles = {
  todo: {
    color: '#000000',
    backgroundColor: '#ffffff',
  },
  progress: {
    color: '#0F408A',
    backgroundColor: '#CCE0FF',
  },
  concluded: {
    color: colors.success[900],
    backgroundColor: '#D1FAD8 ',
  },
};

export type ChipVariants = 'todo' | 'progress' | 'concluded';

interface ActivityStatusProps {
  label: string;
  variant: ChipVariants;
}

export const ActivityStatusBox = ({ label, variant }: ActivityStatusProps) => {
  return (
    <Box
      sx={{
        border: variant === 'todo' ? `1px solid ${colors.neutral[300]}` : undefined,
        backgroundColor: styles[variant].backgroundColor,
        p: '6px 12px',
        borderRadius: '6px',
        width: 'fit-content',
      }}
    >
      <Typography fontWeight="semibold" color={styles[variant].color}>
        {label}
      </Typography>
    </Box>
  );
};
